module.exports = __webpack_public_path__ + "389c3f6a06c3458e337936c868d525a2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-88@2x.png
// module id = 542
// module chunks = 0